import React from "react";
import { Callout, CalloutVariant } from "../Callout";
import { CategoryDto, PICGroup } from "../../../common/service/server/dto/datamap/DataMapDto";

export function TodoListCallout({
  text = "The following personal information categories are not selected for any vendor:",
  groups,
}: {
  text?: string;
  groups: PICGroup[] | CategoryDto[];
}) {
  if (groups.length === 0) {
    return null;
  }

  return (
    <Callout variant={CalloutVariant.Yellow} icon="Info">
      <p>{text}</p>
      <ul>
        {groups.map((g) => (
          <li key={g.id}>
            <strong>{g.name}</strong>
          </li>
        ))}
      </ul>
    </Callout>
  );
}
